import React, { ReactNode } from 'react'
import styled from 'styled-components'

const StyledContainer = styled.div`
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    margin-right: auto;
    margin-left: auto;
    `;

interface ContainerProps {
    children: ReactNode;
  }

  const Container: React.FC<ContainerProps> = ({ children }) => {
  return (
    <StyledContainer>
      {children}
    </StyledContainer>
  )
}

export default Container
